import { t } from "@lingui/macro";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";
import { useSetAtom } from "jotai";
import React, { useLayoutEffect } from "react";
import { Platform } from "react-native";

import { setPreAuthenticatedPathAtom } from "../../features/Authentication/atoms/actions/setPreAuthenticatedPath/setPreAuthenticatedPath";
import { getWebPreAuthenticationPath } from "../../features/Authentication/utils/getWebPreAuthenticationPath";
import { ClubScreen } from "../../screens/Club/ClubScreen";
import { NoNavScreen } from "../../screens/NoNav";
import { NotFoundScreen } from "../../screens/NotFound";
import { TodaysTeeSheetScreen } from "../../screens/TodaysTeeSheet";
import { UnauthenticatedScreen } from "../../screens/Unauthenticated";
import { LegacyRedirect } from "../LegacyRedirect";
import { BaseRoutes } from "./baseRoutes";
import { BaseNavigatorParamList } from "./types";

const Tab = createBottomTabNavigator<BaseNavigatorParamList>();

type SessionClub = {
  slug: string;
};

type BaseNavigatorProps = {
  hasSession: boolean;
  userClubs: SessionClub[];
};

export const BaseNavigator = ({
  hasSession,
  userClubs,
}: BaseNavigatorProps) => {
  const setPreAuthenticatedPath = useSetAtom(setPreAuthenticatedPathAtom);

  useLayoutEffect(() => {
    if (Platform.OS === "web") {
      const path = getWebPreAuthenticationPath();

      if (path) {
        setPreAuthenticatedPath({ path });
      }
    }
  }, [setPreAuthenticatedPath]);

  return (
    <Tab.Navigator
      screenOptions={{ popToTopOnBlur: true }}
      backBehavior={"none"}
      tabBar={() => null}
    >
      <Tab.Screen
        name={BaseRoutes.Unauthenticated}
        children={() => (
          <UnauthenticatedScreen
            hasSession={hasSession}
            userClubs={userClubs}
          />
        )}
        options={{ headerShown: false, title: t`Whoosh` }}
      />
      <Tab.Screen
        name={BaseRoutes.Club}
        component={ClubScreen}
        options={{ headerShown: false, title: t`Whoosh` }}
      />
      <Tab.Screen
        name={BaseRoutes.NotFound}
        component={NotFoundScreen}
        options={{ headerShown: false, title: t`Whoosh` }}
      />
      <Tab.Screen
        name={BaseRoutes.NoNav}
        component={NoNavScreen}
        options={{ headerShown: false, title: t`Whoosh` }}
      />
      <Tab.Screen
        name={BaseRoutes.TodayTeeSheetHack}
        component={TodaysTeeSheetScreen}
        options={{ headerShown: false, title: t`Whoosh` }}
      />
      <Tab.Screen
        name={BaseRoutes.Legacy}
        component={LegacyRedirect}
        options={{ headerShown: false, title: t`Whoosh` }}
      />
    </Tab.Navigator>
  );
};
